<template>
  <!-- eslint-disable -->
  <div :class="classname">
    <template v-if="id === 'hand-picked'">
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="60px"
        height="60px"
        viewBox="0 0 60 60"
      >
        <path class="usp-sprite__circle" d="M45,60c8.3,0,15-6.7,15-15s-6.7-15-15-15s-15,6.7-15,15 S36.7,60,45,60z" />
        <path
          fill="#01324B"
          d="M36.5,7.2c-1.6-1.6-4.3-1.6-5.9,0l-0.5,0.5l-0.5-0.5L27.9,9l2.2,2.2l2.3-2.3c0.7-0.6,1.7-0.6,2.3,0.1 c0.7,0.7,0.7,1.7,0,2.4L30.1,16l-4.6-4.6c-0.7-0.7-0.7-1.7,0-2.4c0.7-0.7,1.7-0.7,2.4,0l1.8-1.8c-1.6-1.6-4.3-1.6-5.9,0 c-1.6,1.6-1.6,4.3,0,5.9l6.4,6.4l6.4-6.4C38.1,11.5,38.1,8.9,36.5,7.2z"
        />
        <path
          fill="#01324B"
          d="M26.2,26.7l-2-6.9c-0.2-0.6-0.3-1-0.4-1.3l0,0c-0.5-1.6-1.7-2.7-3.3-2.9c-0.8-0.1-1.6,0-2.3,0.3l-0.6-6.8 l0-0.2c-0.3-1.5-1.5-2.6-2.9-2.9c-1-0.2-2.1,0-2.9,0.7C10.5,7.6,9.9,9,10,10.5l0.9,12.8c0.1,1.6,0.6,4.8,0.6,4.9l0,0.2l4.5,8.9 c0.2,0.4,0.3,0.9,0.3,1.3l0,4.8l2.5,0l0-4.8c0-0.8-0.2-1.7-0.6-2.4L14,27.6c-0.1-0.7-0.5-3.2-0.6-4.5l-0.9-12.8 c0-0.6,0.2-1.2,0.6-1.5c0.3-0.2,0.6-0.3,0.9-0.2c0.5,0.1,0.8,0.5,1,1l0.9,10l0,0c0,2.3,0.9,6.3,1.6,9.1l0.1,0.4l2.4-0.6L20,28 c-0.4-1.6-1.5-6.3-1.5-8.6c0-0.4,0.1-0.6,0.2-0.7l0-0.1c0.2-0.4,0.8-0.6,1.4-0.5c0.4,0.1,1,0.3,1.3,1.2c0.1,0.3,2.4,8.1,2.4,8.1 c0.7,2.4,0.7,2.5,1.2,4.1c0,1-0.3,7.6-0.5,11.7l2.5,0.1c0.6-11.8,0.5-12.2,0.4-12.4C26.9,29.2,26.9,29.2,26.2,26.7z"
        />
        <path
          fill="#01324B"
          d="M48.4,6.7c-0.9-0.7-1.9-0.9-2.9-0.7C44,6.4,42.9,7.5,42.5,9l-0.6,7c-0.7-0.3-1.5-0.4-2.3-0.3 c-1.6,0.2-2.8,1.3-3.3,2.9l0,0c-0.1,0.3-0.3,0.8-0.4,1.3l-2,6.9c-0.7,2.5-0.7,2.5-1.2,4.2c-0.1,0.3-0.2,0.6,0.4,12.4l2.5-0.1 c-0.2-4.1-0.5-10.7-0.5-11.7c0.5-1.6,0.5-1.7,1.2-4.1c0,0,2.4-8.1,2.4-8.1c0.3-0.9,0.8-1.1,1.3-1.2c0.5-0.1,1.1,0.1,1.4,0.5l0,0.1 c0.1,0.1,0.2,0.3,0.2,0.7c0,2.3-1.2,7-1.5,8.6l-0.1,0.4l2.4,0.6l0.1-0.4c0.7-2.8,1.6-6.8,1.6-9.1L45,9.5c0.1-0.5,0.5-0.9,1-1 c0.3-0.1,0.6,0,0.9,0.2c0.4,0.3,0.7,0.9,0.6,1.5l-0.9,12.8c-0.1,1.3-0.5,3.8-0.6,4.5l-4.3,8.6c-0.4,0.8-0.6,1.6-0.6,2.4l0,4.8 l2.5,0l0-4.8c0-0.5,0.1-0.9,0.3-1.3l4.5-8.9l0-0.2c0-0.1,0.5-3.3,0.6-4.9L50,10.5C50.1,9,49.5,7.6,48.4,6.7z"
        />
      </svg>
    </template>

    <template v-if="id === 'growing'">
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="60px"
        height="60px"
        viewBox="0 0 60 60"
      >
        <path
          class="usp-sprite__circle"
          d="M45,60c8.3,0,15-6.7,15-15s-6.7-15-15-15s-15,6.7-15,15
        S36.7,60,45,60z"
        />
        <path
          fill="#00324B"
          d="M31.6,35.3c-0.1-0.7-0.3-1.9-0.1-3.8c4-0.4,6.9-2,9-5.1c2.4-3.4,3-8,1.9-13c-0.8-3.8-2.3-6.5-2.4-6.6L39.6,6 l-0.9,0.1c-0.1,0-7,1.1-11.1,6.5c-4.2-1.9-9.2-1.5-9.4-1.4l-0.9,0.1l-0.2,0.9c-0.1,0.3-1.5,8.6,1.1,13c1.6,2.6,3.7,3.8,5.2,4.2 c0.9,0.3,1.7,0.4,2.6,0.4c0.6,0,1.2-0.1,1.7-0.2c0.5,0.5,1,1,1.3,1.3c-0.2,2-0.2,3.4,0,4.4c-10.4,0.4-16.7,6.4-19,9l1.9,1.6 C14,43.5,20,37.9,30,37.8c10,0.1,16,5.8,18.1,8.2l1.9-1.6C47.8,41.8,41.6,36,31.6,35.3z M26.1,27.4c-1.8,0-4.1-0.9-5.7-3.5 c-1.6-2.6-1.3-7.6-1-10.3c1.5,0,4.4,0.1,6.9,1.1c-1,1.9-1.6,4.2-1.6,7C24.7,24,25.3,25.9,26.1,27.4z M29.6,28 c-1.1-1.2-2.4-3.3-2.4-6.2c0-9.6,8.3-12.4,11.1-13c1.2,2.5,4.2,10.4,0.2,16.2c-1.6,2.3-3.6,3.6-6.5,4c0.6-2.8,1.8-6.5,4-11.4 l-2.3-1.1C31.5,21.3,30.3,25.1,29.6,28z"
        />
      </svg>
    </template>

    <template v-if="id === 'key-ideas'">
      <svg
        version="1.1"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="60px"
        height="60px"
        viewBox="0 0 60 60"
        enable-background="new 0 0 60 60"
      >
        <path
          class="usp-sprite__circle"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M45,57c8.3,0,15-6.7,15-15s-6.7-15-15-15s-15,6.7-15,15 S36.7,57,45,57z"
        />
        <path fill="#002F54" d="M24.8,21h-7.3v2h7.3V21z" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#002F54"
          d="M10.2,22.2h3.7l0.5,0.8h2.2l-4-7.8h-1l-4,7.8h2.2L10.2,22.2z M12,18.5l0.8,1.7h-1.7L12,18.5z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#002F54"
          d="M50.3,31v-4.8c0-7-5.7-12.8-12.8-12.8c-2,0-3.8,0.5-5.5,1.3V8.3 H0.5v35.2H32V16.8c1.7-1,3.5-1.5,5.5-1.5c6,0,10.8,4.8,10.8,10.8V31H43v12.7h7c3.5,0,6.3-2.8,6.3-6.3C56.2,34,53.7,31.2,50.3,31z M2.5,10.3H30v5.5c-3.2,2.3-5.2,6-5.2,10.3v1.2H7.5v2h17.3V31c-2.3,0-4.3,1.3-5.3,3.2h-12v2h11.2c0,0.3-0.2,0.8-0.2,1.2 c0,1.7,0.7,3.2,1.7,4.3H2.5V10.3z M24.7,41.7c-2.3,0-4.2-2-4.2-4.3s1.8-4.3,4.2-4.3V41.7z M29.8,41.7h-3.2V33h3v8.7H29.8z M30,31 h-3.3v-4.7c0-3,1.2-5.7,3.2-7.7V31H30z M45,33h3.3v8.7H45V33z M50.3,41.5V33c2.2,0.2,3.8,2,3.8,4.3S52.5,41.3,50.3,41.5z"
        />
      </svg>
    </template>
  </div>
</template>

<script>
import bemBlockModifiers from "@/utils/bem-block-modifiers"

export default {
  name: "UspSprite",
  props: {
    id: { type: String, default: null },
    modifiers: { type: Array, default: () => [] }
  },
  computed: {
    classname() {
      return bemBlockModifiers("usp-sprite", [this.id, ...this.modifiers])
    }
  }
}
</script>

<style lang="scss">
.usp-sprite {
  color: $raspberry5;

  &__circle {
    fill: currentColor;
  }

  &--circle-green {
    color: $green5;
  }
}
</style>
